// @ts-ignore
import { BrowserModule } from '@angular/platform-browser';
// @ts-ignore
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// @ts-ignore
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
// @ts-ignore
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HandoffTraceInterceptor } from './shared/interceptor/handoff-trace.interceptor';
import { Apollo } from 'apollo-angular';
import { CookieModule } from 'ngx-cookie';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { AppService } from './app.service';
import { CacheService } from './cache.service';
import { SnackBarService } from './snack-bar.service';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import * as Sentry from "@sentry/angular";
import { CommonModule } from '@angular/common';
import { Router } from "@angular/router";
// @ts-ignore
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VerifyComponent } from './verify/verify.component';
import { DataPickComponent } from './data-pick/data-pick.component';
import { DatasourceGridComponent } from './datasource-grid/datasource-grid.component';
import { CarouselClientsComponent } from './carousel-clients/carousel-clients.component';
// import {LoginComponent} from './login/login.component';
// import {RegistrationComponent} from './registration/registration.component';
import { LoginRegisterComponent } from './login-register/login-register.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatBadgeModule } from '@angular/material/badge';
import { FilterPipe } from './filter.pipe';
import { MatSortModule } from '@angular/material/sort';
import { DynamicStepsComponent } from './dynamic-steps/dynamic-steps.component';
import { CommonDialogComponent } from './common-dialog/common-dialog.component';
import { NotificationModule } from './notification/notification.module';
import { UserComponent } from './user/user.component';
import { NonuserComponent } from './nonuser/nonuser.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { UserPreferencesComponent } from './user-preferences/user-preferences.component';
import { NoInternetComponent } from './no-internet/no-internet.component';
import { FooterComponent } from './footer/footer.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { environment } from '../environments/environment';
// import { MY_FORMATS } from '../app/app.model';
import { MatStepperModule } from '@angular/material/stepper';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import {CdkAccordionModule} from '@angular/cdk/accordion';
/*import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';*/
import { CronEditorModule } from '@winarg/ngx-cron-editor';
// import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { LoginRegisterNewComponent } from './login-register-new/login-register-new.component';
// import { CronJobsModule } from './lib/cron-jobs.module';
// import { ConfigurationComponent } from './configuration/configuration.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

import { RECAPTCHA_BASE_URL, RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha';
import { IntegrationNameRenderComponent } from './integration-name-render/integration-name-render.component';
import { LastSyncStatusRenderComponent } from './last-sync-status-render/last-sync-status-render.component';
import { NextSyncInfoRenderComponent } from './next-sync-info-render/next-sync-info-render.component';
import { StatusRenderComponent } from './status-render/status-render.component';
import { ActionRenderComponent } from './action-render/action-render.component';
import { SourcesRenderComponent } from './sources-render/sources-render.component';
import { FullWidthCellRendererComponent } from './full-width-cell-renderer/full-width-cell-renderer.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { CronDialogComponent } from './cron-dialog/cron-dialog.component';
import { EditIntegrationLinkPipe } from './shared/pipes/edit-integration-link/edit-integration-link.pipe';
import { MenuStatusRenderComponent } from './menu-status-render/menu-status-render.component';
import { SubscriptionsActionRenderComponent } from './account/components/subscription/child-components/subscription-action-renderer/subscription-action-renderer-component';
import { HotToastModule } from '@ngneat/hot-toast';
import { AuthComponent } from './auth/auth.component';
import { LogoutComponent } from './logout/logout.component';
// import {noti}

import { WelcomeEmailComponent } from './welcome-email/welcome-email.component';
import { RouterModule } from '@angular/router';
import { GraphQLModule } from './graphql/graphql.module';
import { GraphQLService } from './graphql/graphql.service';
import { DesktopViewRestrictedComponent } from './shared/components/desktop-view-restricted/desktop-view-restricted.component';
@NgModule({
declarations: [
    AppComponent,
    VerifyComponent,
    DataPickComponent,
    DatasourceGridComponent,
    CarouselClientsComponent,
    //   LoginComponent,
    //   RegistrationComponent,
    LoginRegisterComponent,
    FilterPipe,
    EditIntegrationLinkPipe,
    DynamicStepsComponent,
    CommonDialogComponent,
    UserComponent,
    NonuserComponent,
    UserPreferencesComponent,
    NoInternetComponent,
    FooterComponent,
    LoginRegisterNewComponent,
    IntegrationNameRenderComponent,
    LastSyncStatusRenderComponent,
    NextSyncInfoRenderComponent,
    StatusRenderComponent,
    ActionRenderComponent,
    SourcesRenderComponent,
    FullWidthCellRendererComponent,
    // ConfigurationComponent,
    CronDialogComponent,
    MenuStatusRenderComponent,
    SubscriptionsActionRenderComponent,
    WelcomeEmailComponent,
    AuthComponent,
    LogoutComponent
],
imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    SharedModule,
    HttpClientModule,
    AppRoutingModule,
    MatCardModule,
    MatRippleModule,
    MatInputModule,
    MatSnackBarModule,
    MatMenuModule,
    MatDialogModule,
    MatSelectModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    MatTableModule,
    MatSliderModule,
    MatRadioModule,
    MatCheckboxModule,
    CookieModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    UiSwitchModule,
    NgSelectModule,
    MatGridListModule,
    MatBadgeModule,
    MatSortModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    MatTableModule,
    MatListModule,
    NotificationModule,
    MatFormFieldModule,
    MatStepperModule,
    MatProgressBarModule,
    ScrollingModule,
    CronEditorModule,
    // TableVirtualScrollModule,
    VirtualScrollerModule,
    MatProgressSpinnerModule,
    MatIconModule,
    NgxPaginationModule,
    CdkAccordionModule,
    RecaptchaV3Module,
    HotToastModule.forRoot(),
    RouterModule,
    GraphQLModule,
    DesktopViewRestrictedComponent
],
providers: [
    AppService,
    CacheService,
    SnackBarService,
    MatDatepickerModule,
    Apollo,
    // {
    //   provide: DateAdapter,
    //   useClass: MomentDateAdapter,
    //   deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    // },
    // {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler({
            showDialog: false,
        }),
    },
    {
        provide: Sentry.TraceService,
        deps: [Router],
    },
    ReCaptchaV3Service,
    {
        provide: HTTP_INTERCEPTORS,
        useClass: HandoffTraceInterceptor,
        multi: true,
    },
    {
        provide: RECAPTCHA_BASE_URL,
        useValue: "https://www.google.com/recaptcha/enterprise.js",
    },
    {
        provide: RECAPTCHA_V3_SITE_KEY,
        useValue: environment.recaptchaSiteKey,
    },
    {
        provide: APP_INITIALIZER,
        useFactory: () => () => { },
        deps: [Sentry.TraceService],
        multi: true,
    }
],
bootstrap: [AppComponent]
})
export class AppModule {}
